import type { DependencyList, EffectCallback } from "react";
import { useEffect, useRef } from "react";

/**
 * A customised useEffect that only runs after the component's first render
 * @param effect The effect function to run
 * @param deps The deps used to determine when to run the function
 */
export const useEffectAfterFirstRender = (effect: EffectCallback, deps?: DependencyList) => {
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      return effect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
